import React, { useState, createContext, useEffect } from "react";

export const FilterContext = createContext();

export const FilterContextProvider = (props) => {
    const [filter, setFilter] = useState({value: 0, label: 'ΟΛΕΣ ΟΙ ΕΤΑΙΡΙΕΣ'});
  useEffect((data) => {
    data && setFilter(data)
  }, [filter]);

  return (
    <FilterContext.Provider value={{filter, setFilter}}>
      {props.children}
    </FilterContext.Provider>
  );
};
